import EventBusyRoundedIcon from "@mui/icons-material/EventBusyRounded";
import { Box, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const AvailabilityNotFound = () => {
  const { t } = useTranslation();

  return (
    <Stack
      alignItems="center"
      gap={1.5}
      role="status"
      aria-live="polite"
      sx={{ py: 8, px: 2, textAlign: "center" }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "primary.main",
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
        }}
      >
        <EventBusyRoundedIcon sx={{ fontSize: 36 }} />
      </Box>

      <Typography variant="h6" fontWeight={700} color="primary.main">
        {t("page.schedules.newSchedule.schedule.bot.notFound")}
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 420 }}
      >
        {t("page.schedules.newSchedule.schedule.bot.notFoundDescription")}
      </Typography>
    </Stack>
  );
};

export default AvailabilityNotFound;
